import { render, staticRenderFns } from "./onebox-consent.vue?vue&type=template&id=caecbe7a&"
import script from "./onebox-consent.vue?vue&type=script&lang=js&"
export * from "./onebox-consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports